module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"kr":{"Product":"제품소개","Features":"기능소개","Roadmap":"로드맵","Download":"다운로드","Support":"고객지원"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/App.vue
// module id = 29NJ
// module chunks = 0